import request from "@/utils/request";

export const url = {
  AddConsume: "/api/Account/AddConsume", //入账、消费
  AddPay: "/api/Account/AddPay", //付款
  SettleCheckOut: "/api/Account/SettleCheckOut", // 结账离店
  CreateOrder: "/api/Order/CreateOrder", //生成预订单
  UpdateOrder: "/api/Order/UpdateOrder", //修改订单
  CheckIn: "/api/Order/CheckIn", //办理入住
  ExtendCheckOutDate: "/api/Order/ExtendCheckOutDate", //续住(一天)
  Register: "/api/Order/Register", //开房
  GetOrderPageList: "/api/Order/GetOrderPageList", //查询预订单列表
  GetOrderDetail: "/api/Order/GetOrderDetail", //查询订单明细
  GetOrderLogPageList: "/api/Order/GetOrderLogPageList", //查询订单日志
  GetUnscheduledOrderPageList: "/api/Order/GetUnscheduledOrderPageList", //获取未排房的订单
  EditOrderInfo: "/api/Order/EditOrderInfo", //修改主单信息 联系客人与自定义订单颜色
  MoveOrderDetail: "/api/Order/MoveOrderDetail", //在房态图上拖动房态信息进行换房与续住 (仅在房态图按天显示的模式使用，仅预定单使用)
  GetTransactionPriceList: "/api/Order/GetTransactionPriceList", //查询订单的交易房价 使用场景：入账界面半日租和全日租账项的真实房价
  Cancel: "/api/OrderCancel/Cancel", //取消订单 取消预定中的整单
  CancelDetail: "/api/OrderCancel/CancelDetail", //取消订单明细 取消在住订单中的预定房间明细
  Recover: "/api/OrderCancel/Recover", //恢复订单 恢复被取消的预定订单整单
  RecoverDetail: "/api/OrderCancel/RecoverDetail", //恢复订单明细 恢复在住的订单中被取消的预定房间明细

  VerificationTimeOut: "/api/Account/VerificationTimeOut", //检查是否加收房费 根据订单号检查该订单下所有房间是否加收房费 可以利用RoomNos参数指定只检查该订单下的部分房间
  RentIncrease: "/api/Account/RentIncrease", //加收房费
  GetPrice: "/api/ARI/GetRoomPrice", //查询房价
  Order_Extend: "/api/Order/ExtendCheckOutDate", //续住(一天)
  Order_Revoke: "/api/OrderCancel/RevokeCheckInToBooking", //撤销入住
  Breakfast_GetRoomNos: "/api/Breakfast/GetAppointRoomInfo", //获取在住的房间
  Order_UniteRoom: "/api/Order/UniteRoominfo", //联房
  Order_SplitRoom: "/api/Order/SplitRoominfo", //拆房
  Account_TempLeave: "/api/Account/TempLeave", //暂离
  QueryRoomInfoPage: "/api/Order/QueryRoomInfoPage", //查询订单房间列表 使用场景：选择可以转账的房间
  GetTransferRecords: "/api/Account/GetTransferRecords",
  Transfer: "/api/Account/Transfer",
};

function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class orderApi {
  static Transfer(params, type = "post") {
    return sendRequest(url.Transfer, params, type);
  }
  static GetTransferRecords(params, type = "post") {
    return sendRequest(url.GetTransferRecords, params, type);
  }
  static QueryRoomInfoPage(params, type = "post") {
    return sendRequest(url.QueryRoomInfoPage, params, type);
  }
  /**
   *联房
   */
  static unitRoom(params, type = "post") {
    return sendRequest(url.Order_UniteRoom, params, type);
  }
  static splitRoom(params, type = "post") {
    return sendRequest(url.Order_SplitRoom, params, type);
  }
  static tempLeave(params, type = "post") {
    return sendRequest(url.Account_TempLeave, params, type);
  }
  /**
   *获取在住的房间
   */
  static getRoomNos(params, type = "post") {
    return sendRequest(url.Breakfast_GetRoomNos, params, type);
  }
  /**
   *入账、消费
   */
  static addConsume(params, type = "post") {
    return sendRequest(url.AddConsume, params, type);
  }
  /**
   *付款
   */
  static addPay(params, type = "post") {
    return sendRequest(url.AddPay, params, type);
  }
  /**
   *结账离店
   */
  static settleCheckOut(params, type = "post") {
    return sendRequest(url.SettleCheckOut, params, type);
  }
  /**
   *创建订单
   */
  static createOrder(params, type = "post") {
    return sendRequest(url.CreateOrder, params, type);
  }
  /**
   *更新订单
   */
  static updateOrder(params, type = "post") {
    return sendRequest(url.UpdateOrder, params, type);
  }
  /**
   *办理入住
   */
  static checkIn(params, type = "post") {
    return sendRequest(url.CheckIn, params, type);
  }
  /**
   *续住(一天)
   */
  static extendCheckOutDate(params, type = "post") {
    return sendRequest(url.ExtendCheckOutDate, params, type);
  }
  /**
   *开房
   */
  static openRoom(params, type = "post") {
    return sendRequest(url.Register, params, type);
  }
  /**
   *查询预订单列表
   */
  static getOrderPageList(params, type = "post") {
    return sendRequest(url.GetOrderPageList, params, type);
  }
  /**
   *查询订单明细
   */
  static getOrderDetail(params, type = "post") {
    return sendRequest(url.GetOrderDetail, params, type);
  }
  /**
   *查询订单日志
   */
  static getOrderLogPageList(params, type = "post") {
    return sendRequest(url.GetOrderLogPageList, params, type);
  }
  /**
   *获取未排房的订单
   */
  static getUnscheduledOrderPageList(params, type = "post") {
    return sendRequest(url.GetUnscheduledOrderPageList, params, type);
  }
  /**
   *修改主单信息 联系客人与自定义订单颜色
   */
  static editOrderInfo(params, type = "post") {
    return sendRequest(url.EditOrderInfo, params, type);
  }
  /**
   *在房态图上拖动房态信息进行换房与续住 (仅在房态图按天显示的模式使用，仅预定单使用)
   */
  static moveOrderDetail(params, type = "post") {
    return sendRequest(url.MoveOrderDetail, params, type);
  }
  /**
   *查询订单的交易房价 使用场景：入账界面半日租和全日租账项的真实房价
   */
  static getTransactionPriceList(params, type = "post") {
    return sendRequest(url.GetTransactionPriceList, params, type);
  }
  /**
   *取消订单 取消预定中的整单
   */
  static cancelOrder(params, type = "post") {
    return sendRequest(url.Cancel, params, type);
  }
  /**
   *取消订单明细 取消在住订单中的预定房间明细
   */
  static cancelOrderDetail(params, type = "post") {
    return sendRequest(url.CancelDetail, params, type);
  }
  /**
   *恢复订单 恢复被取消的预定订单整单
   */
  static recoverOrder(params, type = "post") {
    return sendRequest(url.Recover, params, type);
  }
  /**
   *恢复订单明细 恢复在住的订单中被取消的预定房间明细
   */
  static recoverOrderDetail(params, type = "post") {
    return sendRequest(url.RecoverDetail, params, type);
  }
  /**
   *检查是否加收房费
   */
  static verificationTimeOut(params, type = "post") {
    return sendRequest(url.VerificationTimeOut, params, type);
  }
  /**
   *加收房费
   */
  static rentIncrease(params, type = "post") {
    return sendRequest(url.RentIncrease, params, type);
  }
  /**
   *查询房价
   */
  static getPrice(params, type = "post") {
    return sendRequest(url.GetPrice, params, type);
  }
  /**
   *续住一天
   */
  static OrderExtend(params, type = "post") {
    return sendRequest(url.Order_Extend, params, type);
  }

  /**
   *撤销入住
   */
  static OrderRevoke(params, type = "post") {
    return sendRequest(url.Order_Revoke, params, type);
  }
}
